import React from 'react';
import styled from '@emotion/styled';
import { Box } from '@updater/ui-uds';
import { ChatColors } from '../../../configs/chat-colors';

const Bubble = styled(Box)<{ isUser: boolean }>`
  width: 78%;
  min-width: 300px;
  padding: 0.02rem 0.9rem;
  border-radius: 18px;
  color: ${ChatColors.bubble.TEXT};
  align-self: ${({ isUser }: { isUser: boolean }) =>
    isUser ? 'flex-end' : 'flex-start'};
  word-wrap: break-word;
  background: ${({ isUser }: { isUser: boolean }) =>
    isUser ? ChatColors.bubble.USER_BG : ChatColors.bubble.ASSISTANT_BG};

  border: ${ChatColors.bubble.BORDER};

  border-radius: ${({ isUser }: { isUser: boolean }) =>
    isUser ? '12px 0px 12px 12px' : '0px 12px 12px 12px'};
  backdrop-filter: blur(35px);

  * {
    color: inherit !important;
  }
`;

type Props = React.PropsWithChildren<{ isUser: boolean }>;

export const MessageBubble = React.forwardRef<HTMLDivElement, Props>(
  ({ isUser, children }, ref) => {
    return (
      <Bubble
        isUser={isUser}
        role="article"
        aria-label={isUser ? 'Your message' : 'Assistant message'}
        ref={ref}
      >
        {children}
      </Bubble>
    );
  }
);

export default MessageBubble;
